import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocatorApi extends ApiCommon {

  getServiceCenters(modelCode, symptoms, zipcode, sc4uOnly = false, serviceType, warranty): Observable<any> {
    const params = {
      modelCode,
      symptoms,
      zipcode,
      sc4uOnly,
      serviceType,
      warranty,
    };

    return this.apiServer.locator.getServiceCenters(params);
  }
}
